import React, { useEffect, useState } from "react";
import { Typography, Spin } from 'antd';
import SidebarLayout from "../BankerUI/SidebarLayout";
import ReportsForBanker from "../BankerUI/ReportsForBanker";

const { Title } = Typography;

const LoanOfficerReports = () => {

    const [loading, setLoading] = useState(false);
   

    useEffect(() => {
        setLoading(false);
    }, []);

    return (
        <Spin spinning={loading}>
            <SidebarLayout>
                <div>
                    <ReportsForBanker ApplicantId={1}/>
                </div>

            </SidebarLayout >
        </Spin >
    );
};

export default LoanOfficerReports;